export enum templatesTypes {
    TEMPLATES_DATA = 'TEMPLATES_DATA',
    TEMPLATES_SAVE = 'TEMPLATES_SAVE',

}